import React from 'react';
import ReservationStatusRender from '../ReservationStatusRender';
import { Paper, Button, Grid, Typography, withStyles } from 'material-ui';
import CheckIcon from 'material-ui-icons/Check';
import UndoIcon from 'material-ui-icons/Undo';
import { LinearProgress } from 'material-ui/Progress';
import HotelHeaderRender from '../HotelHeaderRender';
import ReservationDetailsRender from '../ReservationDetailsRender';
import InformationPanel from '../../../ui/InformationPanel';
import { updateReservation } from '../../Reservations/reservationsServices';
import ReservationModifyDetailsRender from './ReservationModifyDetailsRender';
import ReservationPricesRender from '../ReservationPricesRender';
import ReservationCancelDetailsRender from '../ReservationCancelDetailsRender';
import OLYWebPageComponent from '../../OLYWebPageComponent';
import { translate } from 'react-i18next';
// import ReservationPricesRender from '../ReservationPricesRender';
import { netPrice } from '../../../defaultValues/netPrice';
import getValue from '../../../defaultValues/getValue';


const styles = theme => ({
    title: {
        fontWeight: 700,
        fontSize: '16px',
    },
    colTitle: {
        fontWeight: 700,
        fontSize: '14px',
        textTransform: 'uppercase',
        border: 0,
        textAlign: 'center',
        height: '40px',
        color: '#555',
    },
    colValue: {
        fontWeight: 300,
        fontSize: '14px',
        border: 0,
        textAlign: 'center',
        height: '40px',
        paddingTop: '12px',
    },
    buttonLabel: {
        fontSize: '12px',
        paddingLeft: '4px',
        fontWeight: 300,
        textDecoration: 'none',
    },
    buttonContainer: {
        marginLeft: '2px',
    },
    button: {
        width: '220px',
        textAlign: 'left'
    },
    expandIcon: {
        color: theme.palette.primary.main
    },
    bookingConditionsTitle: {
        color: theme.palette.primary.main,
        padding: '20px 0 20px 25px',
        fontWeight: 'bold',
        fontSize: '1.2rem'
    },
    locatorTitle: {
        color: theme.palette.primary.contrastText,
        fontSize: '16px',
        fontWeight: 300,
    },
    expansionPanelFilter: {
        backgroundColor: theme.palette.primary.main
    },
    paperFrame: {
        margin: '40px 0px 30px 0px'
    }
});



function renderTerms(services) {
    if (services) {
        let terms = String(services).split(/[\r\n]+/);
        terms.map(t => t = String(t).trim());
        terms = terms.filter(t => t !== '');
        terms.map(t => t += '<br />');
        return terms.map(t => <p>{t}</p>);
    }
    else {
        return '';
    }
}

function renderTOC(terms) {
    if (terms && terms.length > 0) {
        terms = terms.filter(room => room.observations !== '' || room.restrictions !== '' || room.alerts !== '');
        return terms.map(room => {
            return (
                <Typography variant="body1">
                    <b>{room.services}</b>
                    <ul>{renderTerms(room.observations)}</ul>
                    <ul>{renderTerms(room.restrictions)}</ul>
                    <ul>{renderTerms(room.alerts)}</ul>
                </Typography>
            );
        });
    }
}

/* function renderTOC(rooms, props) {
    if (rooms && rooms.length > 0) {
        return rooms.map(roomchild => {
            return roomchild.observations ? (
                <Typography variant="body1">
                    <b>{roomchild.service}</b>
                    <div>
                        <span>
                            {roomchild.observations}
                            <br />
                        </span>
                    </div>
                    <br />
                </Typography>
            ) : (
                <Typography variant="caption">
                    <b>{roomchild.service}</b>
                    <br />
                    {props.t('CONFIRM_BOOKING.NO_CANCEL_POLICY')}
                </Typography>
            );
        });
    }
} */


class ReservationModifyConfirmView extends OLYWebPageComponent {

    constructor(props) {
        super(props);
        this.pageTitle = props.t('PAGE_TITLES.ReservationModifyConfirm');
        this.pageName = 'ReservationModifyConfirm';
        this.pageReference = '';

        let data = JSON.parse(localStorage.getItem('reservationModificationData'));

        this.state = {
            reservation: data.reservation,
            request: data.modificationData,
            diff: data.diff,
            observationData: data.observations,


            completed: 0,
            processing: false,
            mode: 'indeterminate',
            operationstatus: 'info',
            operationtext: '',
            operationtitle: props.t('CONFIRM_BOOKING.PLEASE_WAIT'),

            disableConfirmButton: true
        };
    }


    pageTitleParts() {
        let parts = super.pageTitleParts();
        parts.push(this.state.reservation.olympiaLocator);
        return parts;
    }

    componentDidMount() {
        super.componentDidMount();
        window.scrollTo(0, 0);
    }

    handleSubmit = () => {
        const ID = this.state.reservation.olympiaLocator;
        let request = { ...this.state.request };
        //delete rooms cancelations x el roomRef sino hace JSON Loop
        if (request && request.rooms) {
            request.rooms.map(r => {
                r.cancelations = [];
            });
        }
        request.reservation = this.state.reservation;
        this.setState({ processing: true, operationstatus: 'info' });

        updateReservation(ID, request)
            .then(result => {
                this.setState({
                    operationstatus: 'success',
                    processing: false,
                    mode: 'buffer',
                    operationtitle: this.props.t('CONFIRM_MODIFY_BOOKING.MODIFY_SUCCESS'),
                    operationtext: ''
                });
            })
            .catch(error => {
                if (error) {
                    alert(error.message);
                }
                this.setState({
                    processing: true,
                    mode: 'buffer',
                    operationstatus: 'error',
                    operationtitle: error.message,
                    operationtext: this.props.t('CONFIRM_MODIFY_BOOKING.MODIFY_ERROR_TEXT')
                });
            });
    };

    changeConfirmButtonState = (state) => {
        this.setState({ disableConfirmButton: !state });
    }

    // Codigo Robado del Backend. ;)
    extractCancelacion = (mappedRooms) => {
        if (mappedRooms && Array.isArray(mappedRooms)) {
            let allcancelations = [];
            mappedRooms.forEach((hab, index) => {
                hab.cancelations.forEach(cancelitem => {
                    cancelitem.order = index;
                    cancelitem.roomRef = hab;
                });
                allcancelations = allcancelations.concat(hab.cancelations);
            });
            return allcancelations;
        } else {
            return [];
        }
    };
    /**
     * Devuelve el estado P de una reserva si las rooms son RQ
     */
    getStateFromRooms = (rooms, state) => {
        let contains = false;
        if (rooms && Array.isArray(rooms)) {
            contains = rooms.reduce((acc, room) => {
                return room.available === 'RQ';
            }, false);
        }
        if (contains) {
            return 'P';
        }
        return state;
    }

    render() {
        const { classes, t } = this.props;
        const reservation = this.state.reservation;
        const { cancellationInsurance } = reservation && reservation.hotel ? reservation.hotel : {};
        const hasAssociatedTranfers = reservation && reservation.associatedTransfers.length > 0;
        const request = this.state.request;
        const diff = this.state.diff;
        const dummyReserve = { cancelations: this.extractCancelacion(request.rooms) };
        //OLYB2B-539 - reflejo el estado de la pre-reserva
        request.state = this.getStateFromRooms(request.rooms, request.state);

        //console.log(dummyReserve);

        return (
            <div className="cmsDetails">
                <div className="cmsContainer">
                    <div className="cmsModify">
                        <div className={classes.expansionPanelFilter + ' cmsStatus'}>
                            <ReservationStatusRender
                                reservation={reservation}
                                message={t('MODIFY_BOOKING.BOOKING_STATE') + ' >'}
                            />
                            <div style={{ padding: '22px' }}>
                                <Typography className={classes.locatorTitle}>
                                    {t('MODIFY_BOOKING.BOOKING_LOCATOR') + ' > '}
                                    <span style={{ fontWeight: 700 }}>
                                        {reservation.olympiaLocator}
                                    </span>
                                </Typography>
                            </div>
                        </div>

                        {
                            this.state.operationstatus === 'success' ?
                                (
                                    <div>
                                        <InformationPanel
                                            type={this.state.operationstatus}
                                            title={this.state.operationtitle}
                                            text={this.state.operationtext}>
                                            <br />
                                            <LinearProgress className="cmsProgressBar" value={this.state.completed} variant={this.state.mode} />
                                        </InformationPanel>
                                        <Grid container style={{ marginTop: '16px', marginBottom: '16px', paddingLeft: '2px' }} >
                                            <Grid container item xs={12} direction={'row'} justify={'flex-end'}>
                                                <Button
                                                    variant="raised"
                                                    color={'primary'}
                                                    style={{ marginRight: '-8px', height: '42px' }}
                                                    component="a"
                                                    onClick={() => { window.location.href = '/#/bookings/' + this.state.reservation.olympiaLocator + '/view'; }}
                                                >
                                                    <CheckIcon />
                                                    <Typography variant="button" noWrap={true} style={{ marginLeft: '8px' }}>
                                                        {t('MODIFY_BOOKING.BOOKING_DETAIL')}
                                                    </Typography>
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </div>
                                )
                                :
                                (
                                    <table width="100%" cellSpacing="0" cellSpacing="0">
                                        <tr>
                                            <td width="50%" valign="top">
                                                {this.state.loading ? (
                                                    <div>
                                                        {this.state.info}
                                                        <LinearProgress className="cmsProgressBar" />
                                                        <br />
                                                    </div>
                                                ) : (
                                                        <br />
                                                    )}
                                                <Paper style={{ marginBottom: 0 }}>
                                                    <HotelHeaderRender expanded={this.state.expanded} hotel={reservation ? reservation.hotel : null} />
                                                </Paper>
                                            </td>
                                            <td className="cmsReservationData" width="50%" valign="top">
                                                {/* Detalles de reserva Original */}
                                                <ReservationDetailsRender reservation={reservation} cancellationInsurance={cancellationInsurance} displayprice={true} currentprincelabel={true} style={{ marginTop: 0 }} />

                                                {reservation && cancellationInsurance && cancellationInsurance.active === 'SI' &&
                                                    <ReservationPricesRender
                                                        reservation={reservation}
                                                        cancellationInsurance={reservation.hotel.cancellationInsurance}
                                                        displayToolTip={this.accountName == 'b2bweberoski'}
                                                        onlyShowPVP={!getValue(netPrice, this.currentUser.accountName)}
                                                    />
                                                }
                                                {/* Detalles de reserva Modificada a ser enviada! */}
                                                <ReservationModifyDetailsRender reservation={request} diff={diff} displayprice={true} style={{ marginTop: 0 }} />

                                                {/* Detalles de la reserva*/}
                                                
                                                {/* <ReservationPricesRender reservation={request} onlyShowPVP={!getValue(netPrice, this.currentUser.accountName.toLowerCase())} /> */}
                                                {renderTOC(request.rooms).length !== 0 && <Paper className={classes.paperFrame}>
                                                    <Typography className={classes.bookingConditionsTitle}>
                                                        {t('CONFIRM_MODIFY_BOOKING.BOOKING_CONDITIONS')}
                                                    </Typography>
                                                    <Grid container style={{ paddingRight: '22px' }}>
                                                        <Grid item xs={12}>
                                                            {renderTOC(request.rooms)}
                                                        </Grid>
                                                    </Grid>
                                                </Paper>}

                                                <ReservationCancelDetailsRender
                                                    reservation={dummyReserve}
                                                    hasAssociatedTranfers={hasAssociatedTranfers}
                                                    onCheck={this.changeConfirmButtonState}
                                                />

                                                <Grid container style={{ marginTop: '16px', marginBottom: '16px', paddingLeft: '2px' }} >
                                                    <Grid container item xs={12} direction={'row'} justify={'flex-end'}>
                                                        <Button
                                                            variant="raised"
                                                            color={'secondary'}
                                                            component="a"
                                                            onClick={() => { window.location.href = '/#/bookings/' + this.state.reservation.olympiaLocator + '/view'; }}
                                                            disabled={this.state.loading}
                                                            style={{ marginRight: '16px', height: '42px' }}
                                                            className={'thinText'}>
                                                            <UndoIcon />
                                                            <Typography variant="button" noWrap={true} style={{ marginLeft: '8px' }}>
                                                                {t('CONFIRM_MODIFY_BOOKING.BACK_TO_DETAILS_BUTTON')}
                                                            </Typography>
                                                        </Button>
                                                        <Button
                                                            variant="raised"
                                                            color={'primary'}
                                                            style={{ marginRight: '-8px', height: '42px' }}
                                                            component="a"
                                                            onClick={this.handleSubmit}
                                                            disabled={this.state.disableConfirmButton || this.state.loading || this.state.processing}>
                                                            <CheckIcon />
                                                            <Typography variant="button" noWrap={true} style={{ marginLeft: '8px' }}>
                                                                {t('CONFIRM_MODIFY_BOOKING.CONFIRM_MODIFICATION_BUTTON')}
                                                            </Typography>
                                                        </Button>
                                                    </Grid>
                                                </Grid>
                                                {
                                                    this.state.processing ? (
                                                        <InformationPanel
                                                            type={this.state.operationstatus}
                                                            title={this.state.operationtitle}
                                                            text={this.state.operationtext}>
                                                            <br />
                                                            <LinearProgress className="cmsProgressBar" value={this.state.completed} variant={this.state.mode} />
                                                        </InformationPanel>
                                                    ) : (
                                                            ''
                                                        )}
                                            </td>
                                        </tr>
                                    </table>
                                )
                        }

                        <pre>{ /* JSON.stringify(this.state, null, 4)*/}</pre>
                    </div>
                </div>
            </div>
        );
    }
}

export default translate('translations')(withStyles(styles)(ReservationModifyConfirmView));



// WEBPACK FOOTER //
// ./src/components/Reservation/Modification/ReservationModifyConfirmView.js